/**
 * @desc 对象管理--线索池管理
 * @author zl zhaolun@qfei.cn
 * @date 2023年12月06日09:56:20
 */
export default {
  线索池设置: '线索池设置',
  保有量设置: '保有量设置',
  布局设置: '布局设置',
  线索池列表: '线索池列表',
  线索池名称: '线索池名称',
  线索池成员: '线索池成员',
  搜索线索池名称: '搜索线索池名称',
  一般规则设置: '一般规则设置',
  保有量上限: '保有量上限',
  可设置每个人可保有的线索量上限: '可设置每个人可保有的线索量上限',
  '不在特殊规则中的人员，根据一般规则保有量上限生效': '不在特殊规则中的人员，根据一般规则保有量上限生效',
  '已作废、已转化的线索不计入保有量': '已作废、已转化的线索不计入保有量',
  请输入保有量上限: '请输入保有量上限',
  特殊规则设置: '特殊规则设置',
  每个员工仅可以设置一个特殊规则: '每个员工仅可以设置一个特殊规则',
  '员工被设置特殊规则时，优先使用特殊规则': '员工被设置特殊规则时，优先使用特殊规则',
  添加特殊规则: '添加特殊规则',
  编辑特殊规则: '编辑特殊规则',
  编辑: '编辑',
  删除: '删除',
  选择成员: '选择成员',
  请选择成员: '请选择成员',
  '部门/员工': '部门/员工',
  操作: '操作',
  新增线索池: '新增线索池',
  列表布局: '列表布局',
  请选择列表布局: '请选择列表布局',
  新增布局: '新增布局',
  请选择新增布局: '请选择新增布局',
  编辑布局: '编辑布局',
  请选择编辑布局: '请选择编辑布局',
  详情页布局: '详情页布局',
  请选择详情页布局: '请选择详情页布局',
  编辑线索池: '编辑线索池',
  添加线索池: '添加线索池',
  基础设置: '基础设置',
  请输入线索池名称: '请输入线索池名称',
  请选择管理员: '请选择管理员',
  '管理员可以有多个人，管理员可分配线索，成员只可给自己领取线索': '管理员可以有多个人，管理员可分配线索，成员只可给自己领取线索',
  请选择线索池成员: '请选择线索池成员',
  '领取/分配规则': '领取 / 分配规则',
  成员领取规则: '成员领取规则',
  '成员可见可领取，管理员可分配': '成员可见可领取，管理员可分配',
  成员可自己领取线索池中所有未分配线索: '成员可自己领取线索池中所有未分配线索',
  '成员可见不可领取，管理员可分配': '成员可见不可领取，管理员可分配',
  '成员不可自己领取线索池中线索，只能等待自动分配或管理员手工分配': '成员不可自己领取线索池中线索，只能等待自动分配或管理员手工分配',
  提醒设置: '提醒设置',
  '线索被成员手工领取后，通过消息卡片提醒线索池管理员': '线索被成员手工领取后，通过消息卡片提醒线索池管理员',
  '线索被管理员分配后，通过消息卡片提醒线索负责人': '线索被管理员分配后，通过消息卡片提醒线索负责人',
  自动分配规则: '自动分配规则',
  '开启后必须添加至少一个自动分配规则支持自动将池中线索分给人，也支持分给某个池': '开启后必须添加至少一个自动分配规则支持自动将池中线索分给人，也支持分给某个池',
  '自动分配规则于每晚00:00自动执行，如存在存量未领取线索，将按规则自动分配': '自动分配规则于每晚00:00自动执行，如存在存量未领取线索，将按规则自动分配',
  执行顺序: '执行顺序',
  规则名称: '规则名称',
  规则类型: '规则类型',
  池到人: '池到人',
  池到池: '池到池',
  添加分配规则: '添加分配规则',
  自动回收规则: '自动回收规则',
  开启后必须添加至少一个自动收回规则: '开启后必须添加至少一个自动收回规则',
  '自动收回规则每小时执行一次，如存在满足收回规则的线索，将自动收回': '自动收回规则每小时执行一次，如存在满足收回规则的线索，将自动收回',
  添加回收规则: '添加回收规则',
  规则名称已存在: '规则名称已存在',
  编辑分配规则: '编辑分配规则',
  新建分配规则: '新建分配规则',
  池到人分配规则: '池到人分配规则',
  将线索自动分配给指定的人员: '将线索自动分配给指定的人员',
  池到池分配规则: '池到池分配规则',
  将线索自动分配给指定的线索池: '将线索自动分配给指定的线索池',
  请输入规则名称: '请输入规则名称',
  数据范围: '数据范围',
  所有未领取线索: '所有未领取线索',
  自定义数据范围: '自定义数据范围',
  '如自定义数据范围，则只有满足数据条件的线索才执行此自动分配规则，未满足条件的线索不自动分配': '如自定义数据范围，则只有满足数据条件的线索才执行此自动分配规则，未满足条件的线索不自动分配',
  成员范围: '成员范围',
  线索池所有成员: '线索池所有成员',
  指定成员: '指定成员',
  编辑成员: '编辑成员',
  分配方式: '分配方式',
  按成员姓名首字母排序轮流分配: '按成员姓名首字母排序轮流分配',
  '按成员线索保有量，优先分配给线索量最少的成员': '按成员线索保有量，优先分配给线索量最少的成员',
  分配到: '分配到',
  请选择线索池: '请选择线索池',
  触发时机: '触发时机',
  全选: '全选',
  线索池新增线索: '线索池新增线索',
  线索池导入线索: '线索池导入线索',
  销售退回线索: '销售退回线索',
  自动收回线索: '自动收回线索',
  转移到线索池: '转移到线索池',
  自动分配到线索池: '自动分配到线索池',
  '线索自动分配后，通过消息卡片提醒线索跟进人': '线索自动分配后，通过消息卡片提醒线索跟进人',
  编辑收回规则: '编辑收回规则',
  新建收回规则: '新建收回规则',
  请填写收回规则: '请填写收回规则',
  收回规则: '收回规则',
  '1、已转化的线索不参与自动收回': '1、已转化的线索不参与自动收回',
  '2、标准规则指系统已预置一些定义好的规则，逻辑如下：': '2、标准规则指系统已预置一些定义好的规则，逻辑如下：',
  '未拨打电话：当前日期-最新通话记录的创建日期＞XX天XX小时': '未拨打电话：当前日期-最新通话记录的创建日期＞XX天XX小时',
  '未添加动态记录：当前日期-最新动态记录的创建日期＞XX天XX小时': '未添加动态记录：当前日期-最新动态记录的创建日期＞XX天XX小时',
  '未添加日程：当前日期-最新日程的创建日期＞XX天XX小时': '未添加日程：当前日期-最新日程的创建日期＞XX天XX小时',
  '未编辑线索：当前日期-线索的最后更新日期＞XX天XX小时': '未编辑线索：当前日期-线索的最后更新日期＞XX天XX小时',
  '未添加联系人：当前日期-最新的联系人添加日期＞XX天XX小时': '未添加联系人：当前日期-最新的联系人添加日期＞XX天XX小时',
  '未添加协作人：当前日期-最新的协作人添加日期＞XX天XX小时': '未添加协作人：当前日期-最新的协作人添加日期＞XX天XX小时',
  '未转化线索：当前日期-线索的最新分配日期＞XX天XX小时': '未转化线索：当前日期-线索的最新分配日期＞XX天XX小时',
  获得线索: '获得线索',
  天数: '天数',
  天: '天',
  小时数: '小时数',
  小时内: '小时内',
  小时: '小时',
  如果: '如果',
  请选择: '请选择',
  线索回收: '线索回收',
  标准规则: '标准规则',
  自定义规则: '自定义规则',
  线索回收前: '线索回收前',
  通过消息卡片提醒线索负责人: '通过消息卡片提醒线索负责人',
  '线索自动收回后，通过消息卡片提醒线索负责人': '线索自动收回后，通过消息卡片提醒线索负责人',
  '线索自动收回后，通过消息卡片提醒收回池管理员': '线索自动收回后，通过消息卡片提醒收回池管理员'
};
